import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Overview / metadata / FAQ / bibliography scroll tabs.
 * Extracted verbatim from pages/Articles/Article.js.
 */
export default function ArticleSectionTabs({
  activeMainTab,
  citedKnowledgeBaseSources,
  faqItems,
  hasBibliography,
  scrollToSection,
  totalReferences,
  uniqueFiles,
}) {
  const { t } = useTranslation();

  return (
    <nav className="flex space-x-8">
      <button
        onClick={() => scrollToSection('overview')}
        className={`py-3 px-1 border-b-2 font-medium text-sm transition-colors ${
          activeMainTab === 'overview'
            ? 'border-primary-500 text-primary-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
        }`}
      >
        {t('articles.editor.tabs.overview')}
      </button>
      <button
        onClick={() => scrollToSection('metadata')}
        className={`py-3 px-1 border-b-2 font-medium text-sm transition-colors ${
          activeMainTab === 'metadata'
            ? 'border-primary-500 text-primary-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
        }`}
      >
        {t('articles.editor.tabs.metadata')}
      </button>
      <button
        onClick={() => scrollToSection('faq')}
        className={`py-3 px-1 border-b-2 font-medium text-sm transition-colors ${
          activeMainTab === 'faq'
            ? 'border-primary-500 text-primary-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
        }`}
      >
        {t('articles.editor.tabs.faq')}{faqItems && faqItems.length > 0 ? ` (${faqItems.length})` : ''}
      </button>
      {hasBibliography && (
        <button
          onClick={() => scrollToSection('bibliography')}
          className={`py-3 px-1 border-b-2 font-medium text-sm transition-colors ${
            activeMainTab === 'bibliography'
              ? 'border-primary-500 text-primary-600'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          }`}
        >
          {t('articles.editor.tabs.bibliography')}{citedKnowledgeBaseSources.length > 0 || totalReferences > 0
            ? ` (${citedKnowledgeBaseSources.length || uniqueFiles})`
            : ''}
        </button>
      )}
    </nav>
  );
}
